var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRank5 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 83,
  height: 101,
  viewBox: "0 0 83 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_ddd_1_373)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_1_373)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M60.772 26.276H39.37L35.352 39.478H35.516C36.9373 37.9473 38.5773 36.854 40.436 36.198C42.3493 35.4873 44.5633 35.132 47.078 35.132C49.1553 35.132 50.9047 35.46 52.326 36.116C53.7473 36.7173 54.868 37.5647 55.688 38.658C56.5627 39.6967 57.1913 40.9267 57.574 42.348C57.9567 43.7693 58.148 45.3 58.148 46.94C58.148 49.1267 57.902 51.368 57.41 53.664C56.754 56.8893 55.8793 59.814 54.786 62.438C53.6927 65.062 52.244 67.3307 50.44 69.244C48.6907 71.1027 46.504 72.5513 43.88 73.59C41.256 74.6287 38.0853 75.148 34.368 75.148C31.6347 75.148 29.3387 74.82 27.48 74.164C25.676 73.5627 24.2273 72.77 23.134 71.786C22.0407 70.7473 21.248 69.5993 20.756 68.342C20.3187 67.03 20.1 65.6907 20.1 64.324C20.0453 63.3947 20.0727 62.4927 20.182 61.618C20.346 60.6887 20.4827 59.814 20.592 58.994L20.838 57.436H32.154C32.0447 58.092 31.9353 58.7753 31.826 59.486C31.7167 60.1967 31.662 60.9347 31.662 61.7C31.662 63.1213 31.9353 64.3513 32.482 65.39C33.0833 66.4287 34.2313 66.948 35.926 66.948C38.386 66.948 40.354 66.0187 41.83 64.16C43.306 62.2467 44.4267 59.404 45.192 55.632C45.4653 54.156 45.684 52.844 45.848 51.696C46.012 50.4933 46.094 49.4547 46.094 48.58C46.094 46.612 45.684 45.2453 44.864 44.48C44.044 43.7147 42.732 43.332 40.928 43.332C39.2333 43.332 37.8393 43.824 36.746 44.808C35.6527 45.7373 34.8327 47.022 34.286 48.662H23.708L32.4 17.092H62.658L60.772 26.276Z",
  fill: "#FAFAFA"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_ddd_1_373",
  x: -4,
  y: 0.092041,
  width: 86.658,
  height: 100.056,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_373"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 9
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_1_373",
  result: "effect2_dropShadow_1_373"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_1_373",
  result: "effect3_dropShadow_1_373"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect3_dropShadow_1_373",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_1_373",
  x: 16.0181,
  y: 17.092,
  width: 50.6399,
  height: 66.0559,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_373"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1_373",
  result: "shape"
})))));
export default SvgRank5;